/*
 * GWP Summer 26 — cart discount-code field.
 * "Applica" navigates to /discount/{code}?redirect={current path}, which applies
 * the code at the cart step (same as the affiliate link) so the Collabs 10% and
 * the Dr Free Gift free gift both trigger. Lets customers use the code manually,
 * not only via the affiliate link.
 */
class GwpCode extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.gwp-code__input');
    this.btn = this.querySelector('.gwp-code__btn');
    if (!this.input || !this.btn) return;

    this.btn.addEventListener('click', () => this.apply());
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.apply();
      }
    });
  }

  apply() {
    const code = (this.input.value || '').trim();
    if (!code) {
      this.input.focus();
      return;
    }
    this.btn.setAttribute('disabled', 'disabled');
    const redirect = window.location.pathname + window.location.search;
    window.location.href =
      '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }
}

customElements.define('gwp-code', GwpCode);
